
import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { FormField, FormItem, FormLabel, FormControl } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { UseFormReturn } from "react-hook-form";
import { StoriesFormData } from "./types";

interface StoriesMetadataFormProps {
  form: UseFormReturn<StoriesFormData>;
}

const StoriesMetadataForm: React.FC<StoriesMetadataFormProps> = ({ form }) => {
  const { language } = useLanguage();
  
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <Card>
        <CardHeader>
          <CardTitle className="text-lg">
            {language === "en" ? "English Content" : "المحتوى الإنجليزي"}
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <FormField
            control={form.control}
            name="title_en"
            render={({ field }) => (
              <FormItem>
                <FormLabel>
                  {language === "en" ? "Stories Section Title (English)" : "عنوان قسم القصص (الإنجليزية)"}
                </FormLabel>
                <FormControl>
                  <Input {...field} />
                </FormControl>
              </FormItem>
            )}
          />
          
          <FormField
            control={form.control}
            name="subtitle_en"
            render={({ field }) => (
              <FormItem>
                <FormLabel>
                  {language === "en" ? "Stories Section Subtitle (English)" : "العنوان الفرعي لقسم القصص (الإنجليزية)"}
                </FormLabel>
                <FormControl>
                  <Textarea {...field} className="min-h-24" />
                </FormControl>
              </FormItem>
            )}
          />
          
          <FormField
            control={form.control}
            name="readmore_en"
            render={({ field }) => (
              <FormItem>
                <FormLabel>
                  {language === "en" ? "Read More Button Text (English)" : "نص زر قراءة المزيد (الإنجليزية)"}
                </FormLabel>
                <FormControl>
                  <Input {...field} />
                </FormControl>
              </FormItem>
            )}
          />
        </CardContent>
      </Card>
      
      <Card>
        <CardHeader>
          <CardTitle className="text-lg">
            {language === "en" ? "Arabic Content" : "المحتوى العربي"}
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <FormField
            control={form.control}
            name="title_ar"
            render={({ field }) => (
              <FormItem>
                <FormLabel>
                  {language === "en" ? "Stories Section Title (Arabic)" : "عنوان قسم القصص (العربية)"}
                </FormLabel>
                <FormControl>
                  <Input {...field} dir="rtl" />
                </FormControl>
              </FormItem>
            )}
          />
          
          <FormField
            control={form.control}
            name="subtitle_ar"
            render={({ field }) => (
              <FormItem>
                <FormLabel>
                  {language === "en" ? "Stories Section Subtitle (Arabic)" : "العنوان الفرعي لقسم القصص (العربية)"}
                </FormLabel>
                <FormControl>
                  <Textarea {...field} dir="rtl" className="min-h-24" />
                </FormControl>
              </FormItem>
            )}
          />
          
          <FormField
            control={form.control}
            name="readmore_ar"
            render={({ field }) => (
              <FormItem>
                <FormLabel>
                  {language === "en" ? "Read More Button Text (Arabic)" : "نص زر قراءة المزيد (العربية)"}
                </FormLabel>
                <FormControl>
                  <Input {...field} dir="rtl" />
                </FormControl>
              </FormItem>
            )}
          />
        </CardContent>
      </Card>
    </div>
  );
};

export default StoriesMetadataForm;
